function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#a)",
  d: "M21.9999 20h12c3.3137 0 6 2.6863 6 6v10c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6V26c0-3.3137-2.6863-6-6-6"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#b)",
  d: "M7.99988 24c0-3.3137 2.68632-6 6.00002-6h8c3.3137 0 6 2.6863 6 6v12c0 3.3137 2.6863 6 6 6l-16.0001-.0001c-5.5228 0-9.99992-4.4771-9.99992-10z"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#c)",
  fillOpacity: 0.7,
  d: "M7.99988 24c0-3.3137 2.68632-6 6.00002-6h8c3.3137 0 6 2.6863 6 6v12c0 3.3137 2.6863 6 6 6l-16.0001-.0001c-5.5228 0-9.99992-4.4771-9.99992-10z"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#d)",
  fillOpacity: 0.7,
  d: "M7.99988 24c0-3.3137 2.68632-6 6.00002-6h8c3.3137 0 6 2.6863 6 6v12c0 3.3137 2.6863 6 6 6l-16.0001-.0001c-5.5228 0-9.99992-4.4771-9.99992-10z"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#e)",
  d: "M32.9999 18c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#f)",
  fillOpacity: 0.46,
  d: "M32.9999 18c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#g)",
  fillOpacity: 0.4,
  d: "M32.9999 18c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#h)",
  d: "M17.9999 16c3.3137 0 6-2.6863 6-6 0-3.31371-2.6863-6-6-6s-6 2.68629-6 6c0 3.3137 2.6863 6 6 6"
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#i)",
  fillOpacity: 0.6,
  d: "M17.9999 16c3.3137 0 6-2.6863 6-6 0-3.31371-2.6863-6-6-6s-6 2.68629-6 6c0 3.3137 2.6863 6 6 6"
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "url(#j)",
  fillOpacity: 0.5,
  d: "M17.9999 16c3.3137 0 6-2.6863 6-6 0-3.31371-2.6863-6-6-6s-6 2.68629-6 6c0 3.3137 2.6863 6 6 6"
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  width: 16,
  height: 16,
  x: 4,
  y: 23,
  fill: "url(#k)",
  rx: 3.25
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  width: 16,
  height: 16,
  x: 4,
  y: 23,
  fill: "url(#l)",
  fillOpacity: 0.7,
  rx: 3.25
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M15.4792 28.1054h-2.4471v7.466h-2.0648v-7.466H8.52014v-1.6768h6.95906z"
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(13.4784 0 0 33.2694 39.7967 22.1739)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#a98aff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#8c75ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.565,
  stopColor: "#5f50e2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#3c2cb8"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(68.1539 -7.71566095 14.71355834)scale(32.752 33.1231)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#85c2ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#7588ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6459fe"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "d",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(113.326 8.09285255 17.64474501)scale(19.2186 15.4273)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#bd96ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.686685,
  stopColor: "#bd96ff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "e",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(0 -10 12.6216 0 32.9999 11.5714)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.268201,
  stopColor: "#6868f7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3923b1"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "f",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(40.0516 -.03068196 44.8729095)scale(7.14629 10.3363)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.270711,
  stopColor: "#a1d3ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.813393,
  stopColor: "#a1d3ff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "g",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-41.6581 32.11799918 -43.41948423)scale(8.51275 20.8824)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#e3acfd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.816041,
  stopColor: "#9fa2ff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "h",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(0 -12 15.146 0 17.9999 8.28571)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.268201,
  stopColor: "#8282ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3923b1"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "i",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(40.0516 -3.15465147 21.41641466)scale(8.57554 12.4035)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.270711,
  stopColor: "#a1d3ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.813393,
  stopColor: "#a1d3ff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "j",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(-41.6581 20.38180375 -26.51566158)scale(10.2153 25.0589)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#e3acfd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.816041,
  stopColor: "#9fa2ff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "k",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(45 -25.76345597 16.32842712)scale(22.6274)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.046875,
  stopColor: "#688eff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.946875,
  stopColor: "#230f94"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "l",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(0 11.2 -13.0702 0 12 32.6)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.570647,
  stopColor: "#6965f6",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8f8fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 20.5936,
  x2: 20.5936,
  y1: 18,
  y2: 42,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.801159,
  stopColor: "#6864f6",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5149de"
})));

var SvgMicrosoftTeam = function SvgMicrosoftTeam(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "4 4 36 38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrosoftTeam, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "microsoft-team.svg";
export { ForwardRef as ReactComponent };